import React from "react";
import "./App.css";

// Import your components for different routes
// Creating a Home Page for navigation to different projects

import { Link } from "react-router-dom";
import ProjectCard from "./components/ProjectCard";

import CounterImage from "./projects/counter-app/CounterProject.png";
import TodoImage from "./projects/todo-app/TodoApp.png";
import Navbar from "./components/Navbar";

function App() {
  return (
    <>
      <div className="App">
        
        <header className="App-header">
          <h1 className="heading">
            Welcome to React Frontend Development Roadmap Projects
          </h1>
          <img
            src={
              "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg"
            }
            className="App-logo"
            alt="logo"
          />
        </header>
        <h1 className="heading text-5xl">Topics</h1>
        {/* <hr className="mt-2"/> */}
        <div className="card-container" id="projects">
          <ProjectCard
            ProjectNumber={1}
            Name="Basics of React"
            LinkTo={"basic"}
            imageUrl={""}
          />

          <ProjectCard
            ProjectNumber={2}
            Name="Intermediate React"
            LinkTo={"intermediate"}
            imageUrl={""}
          />
          <ProjectCard
            ProjectNumber={3}
            Name="Advanced React"
            LinkTo={"advanced"}
            imageUrl={""}
          />
        </div>
        <hr className="mt-2"/>
        <h1 className="heading text-5xl mt-4">Projects</h1>
        <div className="card-container" id="projects">
          <ProjectCard
            ProjectNumber={1}
            Name="Counter App"
            LinkTo={"counter"}
            imageUrl={CounterImage}
          />

          <br />
          <ProjectCard
            ProjectNumber={2}
            Name="Todo App"
            LinkTo={"todo-app"}
            imageUrl={TodoImage}
          />
        </div>
      </div>
    </>
  );
}

export default App;
